import apiService from '../../../services/api';
import { AboutModel } from '../model/aboutModel';

export const aboutApi = {
  async fetchContent(): Promise<AboutModel> {
    const response = await apiService.get('system-settings/public/about_content');
    return AboutModel.fromJSON(response.data);
  }
};